/**
 * Shared filter style helper for editor previews.
 *
 * Maps filter names (from filterSelectOptions) to inline CSS style objects.
 * Values are extracted from carousel/style.css filter definitions.
 *
 * For animated filters (rainbow, glitch, etc.) only a static approximation
 * is shown in the editor preview — the full animation plays in the player.
 */

const FILTER_STYLES = {
  "vintage-sepia": { filter: "sepia(100%) saturate(120%) hue-rotate(10deg) brightness(0.95) contrast(1.1)" },
  "cool-blue": { filter: "sepia(0%) saturate(200%) hue-rotate(200deg) brightness(1.1) contrast(1.05)" },
  "warm-orange": { filter: "sepia(80%) saturate(250%) hue-rotate(15deg) brightness(1.15) contrast(1.1)" },
  "neon-pink": { filter: "sepia(60%) saturate(350%) hue-rotate(320deg) brightness(1.2) contrast(1.15)" },
  "electric-cyan": { filter: "sepia(0%) saturate(300%) hue-rotate(180deg) brightness(1.25) contrast(1.1)" },
  "golden-hour": { filter: "sepia(100%) saturate(180%) hue-rotate(25deg) brightness(1.2) contrast(1.05)" },
  "noir-bw": { filter: "grayscale(100%) contrast(1.2) brightness(0.9)" },
  "sunset-red": { filter: "sepia(70%) saturate(300%) hue-rotate(350deg) brightness(1.1) contrast(1.15)" },
  "forest-green": { filter: "sepia(40%) saturate(250%) hue-rotate(100deg) brightness(1.05) contrast(1.1)" },
  "purple-haze": { filter: "sepia(50%) saturate(280%) hue-rotate(280deg) brightness(1.1) contrast(1.1)" },
  "distortion": { filter: "blur(0.5px) contrast(1.1)" },
  "rainbow": { filter: "brightness(1.1) saturate(1.3)" },
  "double-vision": { filter: "blur(0.5px)" },
  "glitch": { filter: "contrast(1.2) brightness(1.1)" },
  "kaleidoscope": { filter: "saturate(1.5) contrast(1.2)" },
  "chromatic-aberration": { filter: "blur(0.5px) contrast(1.2)" },
  "motion-blur": { filter: "blur(3px) contrast(1.1)" },
  "pixelate": { filter: "contrast(1.2) saturate(1.1)", imageRendering: "pixelated" },
  "vhs": { filter: "contrast(1.1) brightness(0.95) saturate(0.8)" },
  "neon-glow": { filter: "brightness(1.2) saturate(1.4) contrast(1.1)" },
};

/**
 * Get an inline style object for a given filter name.
 * Returns an empty object if no filter or unknown filter.
 */
export const getFilterStyle = (filterName) => {
  if (!filterName) return {};
  return FILTER_STYLES[filterName] || {};
};
